// Terima Kiriman (`/operations/receive`): the operator receives a Surat Jalan at its own Titik Distribusi.
// Formal and calm: "Reader" (never "gateway"), "Titik Distribusi", no exclamation marks, no "…" in action labels.

export const RECEIVE_LIST = {
  sub: (place: string) => `di ${place}`,
  heading: (place: string) => `Menuju ${place}`,
  empty: (place: string) => `Belum ada kiriman menuju ${place}. Kiriman muncul di sini setelah diberangkatkan dari asal.`,
  cylinders: (n: number) => `${n} tabung`,
  inTransit: 'Dalam pengiriman',
  eta: (t: string) => `tiba ±${t}`,
  departed: (t: string) => `berangkat ${t}`,
  late: 'Melewati perkiraan tiba',
  unloading: 'Sedang dibongkar',
  start: 'Mulai bongkar',
  continue: 'Lanjutkan',
  receivedToday: 'Diterima hari ini',
  receivedMeta: (got: number, total: number, origin: string) => `${got} dari ${total} tabung · dari ${origin}`,
  loadingBusy: 'Titik Distribusi ini sedang memuat kiriman. Jeda pemuatan terlebih dahulu sebelum membongkar.',
  open: 'Buka',
} as const;

export const RECEIVE_UNLOAD = {
  /** after the counted number: "12 dari 40 tabung diterima" */
  progressOf: (total: number) => `dari ${total} tabung diterima`,
  from: (origin: string) => `Dari ${origin}`,
  complete: 'Lengkap',
  left: (k: number) => `${k} belum diterima`,
  progressLabel: 'Tabung diterima',
  notStarted: 'Pembongkaran belum dimulai. Tekan Mulai bongkar untuk mulai menerima tabung.',
  start: 'Mulai bongkar',
  paused: 'Pemindaian dijeda. Tabung yang melewati Reader tidak dicocokkan sampai dilanjutkan.',
  resume: 'Lanjutkan',
  /** with a Reader working here */
  readerLive: 'Dekatkan tabung ke Reader',
  readerLiveSub: 'Tabung yang terbaca langsung dicocokkan dengan Surat Jalan.',
  /** manual receiving: the main input without a Reader, the fallback with one */
  manualTitle: 'Ketik nomor seri',
  manualSub: 'Nomor seri tercetak di badan tabung. Tekan Enter untuk menambahkan.',
  manualFallback: 'Reader tidak membaca? Ketik nomor seri',
  manualNote: 'Hanya untuk tabung yang benar-benar ada di depan Anda. Tercatat manual atas nama Anda.',
  add: 'Terima',
  manualDone: (serial: string) => `${serial} diterima`,
  sectionMissing: 'Belum diterima',
  sectionGot: 'Diterima',
  sectionExtras: 'Tidak ada di Surat Jalan',
  missingEmpty: 'Semua tabung pada Surat Jalan ini sudah diterima.',
  missingHint: 'Tabung yang tertinggal dapat diterima kapan saja sebelum penerimaan diselesaikan.',
  gotEmptyReader: 'Belum ada tabung yang diterima. Dekatkan tabung ke Reader saat dibongkar.',
  gotEmptyManual: 'Belum ada tabung yang diterima. Ketik nomor seri tabung di atas.',
  loadedAt: (t: string) => `dimuat ${t}`,
  manual: 'manual',
  more: (n: number) => `Tampilkan ${n} lainnya`,
  finishAll: 'Selesaikan',
  finish: 'Selesaikan penerimaan',
  hintNotStarted: 'Tekan Mulai bongkar terlebih dahulu.',
  hintBusy: 'Menunggu proses sebelumnya selesai.',
  hintMissing: (k: number) => `${k} tabung belum diterima. Tabung tersebut akan dicatat tidak sampai.`,
  hintAll: 'Semua tabung sudah diterima.',
} as const;

export const RECEIVE_FINISH = {
  titleAll: (n: number) => `Selesaikan penerimaan ${n} tabung?`,
  titleMissing: (k: number) => `Selesaikan dengan ${k} tabung belum diterima?`,
  got: (n: number, place: string) => `${n} tabung dicatat di ${place}.`,
  missing: (k: number) => `${k} tabung akan dicatat tidak sampai dan peringatan dibuat.`,
  offline: 'Koneksi langsung sedang terputus: pembacaan terakhir mungkin belum tampil. Periksa jumlah tabung terlebih dahulu.',
  noteRequired: 'Catatan penerima (wajib)',
  noteOptional: 'Catatan (opsional)',
  noteHelp: 'Contoh: Sudah diperiksa di bak truk, tabung tidak ada.',
  confirmAll: 'Selesaikan',
  confirmMissing: 'Selesaikan penerimaan',
} as const;

export const RECEIVE_RESULT = {
  complete: 'Kiriman diterima lengkap',
  discrepancy: (k: number) => `Diterima dengan selisih ${k}`,
  received: 'Diterima',
  missing: 'Tidak sampai',
  of: (total: number) => `dari ${total} tabung`,
  from: 'Dari',
  at: 'Waktu',
  extras: 'Di luar Surat Jalan',
  extrasValue: (n: number) => `${n} tag`,
  missingList: (k: number) => `Tidak sampai (${k})`,
  note: (n: string) => `Catatan: “${n}”`,
  alertMade: 'Peringatan telah dibuat untuk tabung yang tidak sampai.',
  openNote: 'Lihat Surat Jalan',
  another: 'Terima kiriman lain',
  home: 'Kembali ke Beranda',
  notReceivable: (n: string) => `Surat Jalan ${n} tidak dapat diterima`,
  notReceivableBody: 'Status Surat Jalan ini tidak sedang menunggu penerimaan.',
} as const;
